export default __webpack_public_path__ + "static/media/espago-screenshot-02.6ddd43db.png";